"use client";

import type { ComponentType } from "react";

import { MarketingFeatureCardSlot } from "@/components/redesign/MarketingFeatureCard";
import type { CardBlockProps } from "@/puck/types";

type CardBlockRenderProps = CardBlockProps & {
  visual?: ComponentType<{ className?: string }>;
};

export function CardBlock({
  title,
  description,
  visual: Visual,
  background = "voiceCard",
  radius = "2xl",
  bordered = true,
  interactive = true,
}: Readonly<CardBlockRenderProps>) {
  return (
    <MarketingFeatureCardSlot
      title={title}
      description={description}
      background={background}
      radius={radius}
      bordered={bordered}
      interactive={interactive}
      visual={Visual}
    />
  );
}
